export default __webpack_public_path__ + "static/media/D100_RoHS.de54eeb8.pdf";